import { createStore } from "vuex";

export default createStore({
    state: {
        initialized: false,
        selection: {},
        personData: {},
        ticketFields: {},
        personFields: {},
        loading: true,
        offers: {},
        maxOrderAmounts: {},
        personalize: false,
        personalized: false,
        fullDescription: false,
        onlyNoChipTicketsSelected: false,
        allDataCollected: false,
        couponSwitch: false,
        couponCode: '',
        couponChecked: false,
        couponType: null,
        couponValue: null,
        couponOffers: [],
        couponDiscount: 0,
        couponResponse: null,
        donationSwitch: false,
        donationAmount: null,
        newsletterSignup: false,
        paymentType: '',
        paymentOptions: [],
        paymentCountryRules: null, // php-core CountryPaymentMethods::toArray(), null = no country rules
        billingCountry: '',
        tender: '',
        terminalId: '',
        ownerData: {},
        currentStep: 0,
        price: 0,
        total: 0,
        checkoutTracked: false, // in the checkout, does not report the checkout a second time
        doOctoberRequest: () => {},
    },
    mutations: {
        init(state, payload) {
            const settings = payload.settings;
            this.commit("updateOffers", settings)
            state.personalize = settings.personalize;
            if (state.personalize) {
                state.personalize_fields = settings.personalize_fields;
                state.vue_personalize_fields = settings.vue_personalize_fields;
            }
            state.withCompany = settings.with_company;
            state.paymentOptions = settings.paymentOptions;
            state.doOctoberRequest = payload.doOctoberRequest;
            state.ownerData = settings.ownerData || {};
            state.withCompany = settings.with_company;
            state.paymentOptions = settings.paymentOptions;
            state.doOctoberRequest = payload.doOctoberRequest;
            state.ownerData = settings.ownerData || {};
            state.paymentCountryRules = settings.payment_country_rules || null;

            // A coupon handed in by the link the buyer followed (?coupon=CODE, or the
            // embed passing it on). It is applied before anything else may set it.
            const initialCouponCode = payload.initialCouponCode || null;
            if (settings.stored?.selection) {
                UIkit.modal.confirm(payload.$t('Es wurden bereits Eingaben vorgenommen. Sollen diese verwendet werden?'), {i18n: {ok: payload.$t('Ja'), cancel: payload.$t('Nein')}}).then(() => {
                    // @gotcha The link wins over the cookie store. Its code is the one the
                    //   buyer arrived with and whose products are already on screen, while
                    //   the store may still carry a code from an earlier visit — restoring
                    //   that one would swap the coupon under the buyer without a word.
                    const couponKeys = ['couponCode', 'couponSwitch', 'couponType', 'couponValue', 'couponDiscount'];
                    Object.keys(settings.stored).forEach(key => {
                        if (initialCouponCode && couponKeys.includes(key)) return;
                        state[key] = settings.stored[key];
                    });
                }, () => {
                    this.commit("removeCookieStore");
                });
            }
            // @gotcha Only the code travels, never `couponSwitch`. The switch is what the
            //   checkout reads to decide whether to charge a discount, and it is set by the
            //   coupon field once the backend has confirmed the code — a link carrying an
            //   expired or mistyped code would otherwise make the checkout complain about an
            //   invalid coupon the buyer never entered. A shop with coupons switched off
            //   ignores the parameter altogether.
            if (initialCouponCode && settings.coupons_enabled) {
                state.couponCode = initialCouponCode;
            }
            state.initialized = true;
            state.personData = {};
        },
        updateOffers(state, payload) {
            Object.keys(payload.offers).forEach((offerId) => {
                if (typeof state.offers[offerId] == 'undefined' || payload.offers[offerId].coupon_highlight) {
                    state.offers[offerId] = payload.offers[offerId];
                    state.offers[offerId].amount = 0;
                }
            });
            state.maxOrderAmounts = payload.maxOrderAmounts;
        },
        removeCookieStore(state) {
            state.doOctoberRequest('onForgetStore');
        },
        addTicket(state, payload) {
            state.selection[payload.ticketId] = state.selection[payload.ticketId]
                ? state.selection[payload.ticketId]
                : {ticket: state.offers[payload.ticketId]};
            state.selection[payload.ticketId].amount = payload.amount;
            state.selection[payload.ticketId].option = payload.option;
            if (state.selection[payload.ticketId].amount == 0) {
                delete state.selection[payload.ticketId];
            } else if (state.personalize) {
                state.allDataCollected = false;
                if (typeof state.offers[payload.ticketId].no_chip == 'undefined') {
                    state.selection[payload.ticketId].persons = state.selection[payload.ticketId].persons ? state.selection[payload.ticketId].persons : [];
                    const personAmount = Object.keys(state.selection[payload.ticketId].persons).length;
                    if (personAmount > payload.amount) {
                        state.selection[payload.ticketId].persons.splice(payload.amount - 1, personAmount - payload.amount)
                    }
                    for (let i = 0; i < payload.amount; i++) {
                        // @gotcha Leeres Objekt, KEIN Feld vorbelegen — auch nicht
                        //   mit ''. PersonalizeTicketForm schreibt dieses Objekt im
                        //   mounted-Hook per form$.update() ins Formular, und die
                        //   globale Vueform-Config steht auf validateOn:'change'.
                        //   Ein geschriebener Wert zaehlt als Aenderung, das Feld
                        //   wird also sofort validiert. Der frueher hier stehende
                        //   Seed {firstname: ''} liess dadurch "Vorname muss
                        //   ausgefuellt werden." erscheinen, bevor der Kaeufer den
                        //   Schritt ueberhaupt gesehen hatte — und zwar NUR bei
                        //   diesem einen Feld, weil nur dieser Schluessel existierte.
                        state.selection[payload.ticketId].persons[i] = state.selection[payload.ticketId].persons[i] ? state.selection[payload.ticketId].persons[i] : {};
                    }
                }
            }
            this.commit("updatePrice");
            state.onlyNoChipTicketsSelected = true
            for (let ticketId in state.selection) {
                if (typeof state.offers[ticketId].no_chip == 'undefined') {
                    state.onlyNoChipTicketsSelected = false
                }
            }
        },
        nullTicket(state) {

            if (state.selection[payload.ticketId] === undefined) {
                return;
            }

            delete state.selection[payload.ticketId];

            this.commit("updatePrice");
            const commitWhat = (!Object.keys(state.selection).length) ? "removeCookieStore" : "updateSession";
            this.commit(commitWhat);
        },
        updatePrice(state) {
            if (!Object.keys(state.selection).length) {
                // An emptied cart ends the purchase — the next one gets its own checkout
                // event. Checked here because every way of changing the cart passes through.
                state.checkoutTracked = false;
            }
            state.price = 0;
            state.total = 0;
            state.couponDiscount = 0
            Object.keys(state.selection).forEach((selectionTicketId) => {
                const selection = state.selection[selectionTicketId]
                let ticketPrice = selection.ticket.price * selection.amount
                state.price += ticketPrice
                if (state.couponValue && (state.couponOffers.length == 0 || state.couponOffers.includes(parseInt(selectionTicketId)))) {
                    if (state.couponType == 'absolute') {
                        state.couponDiscount = Math.min(state.couponDiscount + ticketPrice, state.couponValue)
                    }
                    if (state.couponType == 'relative') {
                        state.couponDiscount += Math.min(ticketPrice, (0.01 * state.couponValue * ticketPrice).toFixed(2))
                    }
                }
            });
            state.total = state.price - state.couponDiscount
            if (state.donationSwitch && state.donationAmount && parseInt(state.donationAmount)) {
                state.total += Math.abs(parseInt(state.donationAmount))
            }
        },
        removeTicket(state, payload) {
            if (state.selection[payload.ticketId].persons[payload.index]) {
                state.selection[payload.ticketId].persons.splice(payload.index, 1)
            }
            state.selection[payload.ticketId].amount--;
            if (!state.selection[payload.ticketId].amount) {
                delete state.selection[payload.ticketId];
            }
            this.commit("updatePrice");
            if (!Object.keys(state.selection).length) {
                this.commit("removeCookieStore");
            } else {
                this.commit("updateSession");
            }
        },
        updateSession(state) {
            const data = {
                selection: state.selection,
                personData: state.personData,
                paymentType: state.paymentType,
                currentStep: state.currentStep,
                personalized: state.personalized,
                onlyNoChipTicketsSelected: state.onlyNoChipTicketsSelected,
                couponCode: state.couponCode,
                couponSwitch: state.couponSwitch,
                couponType: state.couponType,
                couponValue: state.couponValue,
                couponDiscount: state.couponDiscount,
                donationSwitch: state.donationSwitch,
                donationAmount: state.donationAmount,
                newsletterSignup: state.newsletterSignup,
                allDataCollected: state.allDataCollected,
                price: state.price,
                total: state.total,
                checkoutTracked: state.checkoutTracked
            };
            state.doOctoberRequest('onStore', {data: JSON.stringify(data)});
        },
        emitScroll() {
            window.setTimeout(() => {
                window.top.postMessage({scrollTop: true}, '*')
            },500)
        }
    },
});

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
}
